import loc from './location';
import camera from './camera';
import permission from './permissions';
import { EventBus } from './event-bus';

// async function obj (data,success, event, msg) {
//     return new Promise(function(resolve) {
//         resolve({
//             data: data,
//             success: success,
//             event: event,
//             msg: msg
//         });
//     });
// }

async function test (which,ctx) {

    var result = []

    switch(which) {


        case 'all':

                EventBus.$emit('diag', {msg: 'Diagnostic process has been started'});

            try {

                // location permission
                try {
                    EventBus.$emit('diag', {data: null ,success: true, event: 'locationPermission', msg: 'Checking for location permission'} )
                    var locPermission = await permission.location.authorized()
                    EventBus.$emit('diag', {data: locPermission ,success: true, event: 'locationPermission', msg: 'Location permission is granted'} )
                }catch(e) {
                    EventBus.$emit('diag', {data: null ,success: false, event: 'locationPermission', msg: 'Failed to get the location permission'} )
                    return
                }

                // location
                try {
                    EventBus.$emit('diag', {data: null, success: true, event: 'location', msg: 'Getting location details'});
                    var locRes = await loc.get()
                    EventBus.$emit('diag', {data: locRes ,success: true, event: 'location', msg: 'Got location details'});
                } catch (e){
                    EventBus.$emit('diag', {data: null ,success: false, event: 'location', msg: 'Failed to get the location details'} )
                    return
                }


                // camera permission
                try {
                    EventBus.$emit('diag', {data: null ,success: true, event: 'cameraPermission', msg: 'Checking for camera permission'} )
                    var camPermission = await permission.camera.authorized()
                    EventBus.$emit('diag', {data: camPermission ,success: true, event: 'cameraPermission', msg: 'Camera permission is granted'} )
                }catch(e) {
                    EventBus.$emit('diag', {data: null, success: false, event: 'cameraPermission', msg: 'Failed to get the camera permission'} )
                    return
                }

                // camera
                try {
                    EventBus.$emit('diag', {data: null ,success: true, event: 'camera', msg: 'Checking the camera'} )
                    var camRes = await camera.getPicture(ctx, {
                        destinationType: navigator.camera.DestinationType.FILE_URI,
                    })
                    EventBus.$emit('diag', {data: camRes ,success: true, event: 'camera', msg: 'Successfully checked the camera'} )
                }catch(e) {
                    EventBus.$emit('diag', {data: null ,success: false, event: 'camera', msg: 'Failed to get the camera details'} )
                    return
                }


            } catch(e) {
                console.log("error",e)
                return result.push(e)
            }

            return result

        break

        case "location" : 

            try{    
                
                return Promise.resolve(await loc.get())
                
            }catch(e) {
                console.log("Failed loc" , e)
                return Promise.reject(e)
            }
            
        break

        case "camera" : 

            try{

                return Promise.resolve( await camera.getPicture(ctx, {
                    destinationType: navigator.camera.DestinationType.FILE_URI,
                }) ) 
            }catch(e) {
                console.log("Failed image" , e)
                return Promise.reject(e)
            }
            
        break

        case "permission.location" : 

        try{

            return Promise.resolve( await permission.location.authorized() )
        }catch(e) {
            console.log("Failed Permissions" , e)
            return Promise.reject(e)
        }

        break

        case "permission.camera" : 

        try{

            return Promise.resolve( await permission.camera.authorized() )
        }catch(e) {
            console.log("Failed camera" , e)
            return Promise.reject(e)
        }

        break

        case "permission.location.request" :



            try{

                return Promise.resolve( await permission.location.request() )
            }catch(e) {
                console.log("Failed Requeset" , e)
                return Promise.reject(e)
            }
    

        break

        case "permission.camera.request" :



            try{

                return Promise.resolve( await permission.camera.request() )
            }catch(e) {
                console.log("Failed Requeset" , e)
                return Promise.reject(e)
            }
    

        break

        case "report" : 

        try{
            return Promise.resolve( {
                cameraEnabled : await permission.camera.authorized() ,
                locationEnabled : await permission.location.enabled(),
                locationAuth : await permission.location.authorized(),
                device : JSON.stringify(device)
            } )

        }catch(e){
            return Promise.reject(e)
        }

           

        break

    }

}


export default test